import { mainApi } from "@/api/api";
import { PreviewInvoice } from "@/shared/previewInvoice/PreviewInvoice";
import { Spinner } from "@/shared/spinner/Spinner";
import { InvoiceData } from "@/types";
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import "./SharedInvoice.scss";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfDocument from "../pdf/Pdf";

export const SharedInvoice = () => {
    const { token } = useParams();
    const [previewConfig, setPreviewConfig] = useState<InvoiceData>();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            try {
                mainApi.getInvoice(token).then((res) => {
                    if (res) setPreviewConfig(res);
                });
            }
            finally {
                setIsLoading(false);
            }
        }
        else navigate("/");
    }, [token, navigate]);
    return <section className="shared-invoice">
        {isLoading && <Spinner />}
        {previewConfig &&
            <>
                <div className="shared-invoice__controls">
                    <PDFDownloadLink
                        className="shared-invoice__download"
                        document={<PdfDocument data={previewConfig} />}
                        fileName={`Invoice #${previewConfig.invoiceNumber}.pdf`}
                    >
                        Download invoice
                    </PDFDownloadLink>
                </div>
                <PreviewInvoice previewConfig={previewConfig} />
            </>
        }
    </section>
}